// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"bdac790a","633":"b3a6a75a","882":"c853c9e8"}[chunkId] + ".chunk.css";
};